function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (Array, Math, available, displayTotal, i18n) {
      var displayTotal = Math.min(available, 9);
// iterate new Array(displayTotal)
;(function(){
  var $$obj = new Array(displayTotal);
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var star = $$obj[i];
var dist  = Math.abs(Math.floor(displayTotal / 2) - i)
var klass = "star-delay-" + dist;
if (i < available) klass += " active";
if (available > 4) klass += " bunched";
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["star",klass], [false,true]), false, true)) + "\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var star = $$obj[i];
var dist  = Math.abs(Math.floor(displayTotal / 2) - i)
var klass = "star-delay-" + dist;
if (i < available) klass += " active";
if (available > 4) klass += " bunched";
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["star",klass], [false,true]), false, true)) + "\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"text-bold text-pre\" role=\"alert\"\u003E" + (pug_escape(null == (pug_interp = i18n("stars.available", { smart_count: available })) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }.call(this, "Array" in locals_for_with ?
        locals_for_with.Array :
        typeof Array !== 'undefined' ? Array : undefined, "Math" in locals_for_with ?
        locals_for_with.Math :
        typeof Math !== 'undefined' ? Math : undefined, "available" in locals_for_with ?
        locals_for_with.available :
        typeof available !== 'undefined' ? available : undefined, "displayTotal" in locals_for_with ?
        locals_for_with.displayTotal :
        typeof displayTotal !== 'undefined' ? displayTotal : undefined, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined));
    ;;return pug_html;};module.exports=template;